import { render, staticRenderFns } from "./EducationMenu.vue?vue&type=template&id=3e7fc1fa&scoped=true"
import script from "./EducationMenu.vue?vue&type=script&lang=js"
export * from "./EducationMenu.vue?vue&type=script&lang=js"
import style0 from "./EducationMenu.vue?vue&type=style&index=0&id=3e7fc1fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7fc1fa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducationMenuItem: require('/builds/gb-developers/geekbrains-client/components/pages/education/EducationMenu/EducationMenuItem.vue').default,EducationMenuToggle: require('/builds/gb-developers/geekbrains-client/components/pages/education/EducationMenu/EducationMenuToggle.vue').default})
